import { render, staticRenderFns } from "./MbBalloonsGame.vue?vue&type=template&id=78107c99&scoped=true&"
import script from "./MbBalloonsGame.vue?vue&type=script&lang=js&"
export * from "./MbBalloonsGame.vue?vue&type=script&lang=js&"
import style0 from "./MbBalloonsGame.vue?vue&type=style&index=0&id=78107c99&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78107c99",
  null
  
)

export default component.exports